export class User {
     username: string;
     userpassword: string;
     useremail: string;
     token: string;
     fullname:string;
     businessname:string;
}